import _ from 'lodash';
import Parser from './Parser';
import {
  filtersAutocompleteRule,
  filtersBooleanRule,
  filtersFacetRule,
  filtersNavigationRule,
  filtersRangeRule,
  filterDateRangeRule,
  filtersTextRule,
} from './rules';
import encodeChars from './rules/encodeChars';

const ruleSet = {
  range_filter: filtersRangeRule,
  date_filter: filterDateRangeRule,
  list_filter: filtersBooleanRule,
  simple_filter: filtersTextRule,
  facet: filtersFacetRule,
  autocomplete: filtersAutocompleteRule,
};

export const getFilters = (filtersOptions) => {
  const filters = [];
  if (filtersOptions?.groups) {
    Object.values(filtersOptions.groups).forEach(group =>
      group.subgroups.forEach(subgroup =>
        subgroup.filters.forEach((filter) => {
          filters.push(filter);
        })));
  }

  return filters;
};

export default class FiltersParser extends Parser {
  parseToUrl(data, filtersOptions) {
    const filters = getFilters(filtersOptions);
    const result = {};

    this.exclude = filters
      .map((filter) => {
        const item = data[filter.name];

        if (!item || !ruleSet[item.type].encode) {
          return encodeChars.colon(filter.name);
        }

        if (filtersNavigationRule.names.includes(filter.name)) {
          return '';
        }

        if (ruleSet[item.type].multiple) {
          const arr = ruleSet[item.type].encode(item, filter);
          arr.forEach(([key, val]) => {
            result[key] = val;
          });

          return '';
        }

        const [key, val] = ruleSet[item.type].encode(item, filter);
        result[key] = val;
        return '';
      })
      .filter(filter => !!filter);

    return super.parseToUrl(result);
  }

  parseToData(url, filtersOptions) {
    const filters = getFilters(filtersOptions);
    const data = {};
    const urlData = {};
    // Split URL into key-value pairs by & and remove ? symbol.
    url
      .replace('?', '')
      .split('&')
      .map(item => item.split('='))
      .forEach((item) => {
        urlData[item[0]] = item[1];
      });
    this.exclude = filters
      .map((filter) => {
        const encodedName = encodeChars.colon(filter.name);
        let value = urlData[encodedName];
        if (filter.settings.type === 'range_filter') {
          const minVal = urlData[`${encodedName}-min`];
          if (minVal) {
            value = {min: +minVal};
          }
          const maxVal = urlData[`${encodedName}-max`];
          if (maxVal) {
            value = {...(value || {}), max: +maxVal};
          }
        }

        if (filter.settings.type === 'date_filter') {
          const minVal = urlData[`${encodedName}-min`];
          if (minVal) {
            value = {from: minVal};
          }
          const maxVal = urlData[`${encodedName}-max`];
          if (maxVal) {
            value = {...(value || {}), to: maxVal};
          }
        }

        if (value) {
          if (ruleSet[filter?.settings?.type]?.decode) {
            data[filter.name] = ruleSet[filter.settings.type].decode(value, filter);
          }
          return '';
        }

        return encodedName;
      })
      .filter(filter => !!filter);
    this.data = data;

    return this;
  }
}

/**
 * Whether the URL search string contains filter params restorable from backend config.
 * @returns {boolean|null} true if filter params present, false if config loaded and none,
 *   null if filter config is not loaded yet.
 */
export function urlHasRestorableFilterParams(search, filtersOptions) {
  if (!search) {
    return false;
  }
  if (!filtersOptions?.groups) {
    return null;
  }
  const [, data] = new FiltersParser().parseToData(search, filtersOptions).getResult();
  return !_.isEmpty(data);
}
